import styled from "styled-components";

export const NotificationItemFooter = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
